module.exports = __webpack_public_path__ + "media/form-type-page/keyboard-e88833ab.svg";